<template>
  <v-date-picker
    v-model="localValue"
    v-bind="$attrs"
    v-on="$listeners"
    scrollable
    color="primary"
    show-current
    show-adjacent-months
    :events="daysArray"
    event-color="error"
    :locale="$root.$i18n.locale"
    :first-day-of-week="1"
  />
</template>

<script>
import localValue from '@/mixins/localValue';
import { toDate, isDate, formatISO } from 'date-fns';
import { safeParseISO } from '@/functions/DateHelpers';

function dateToDateStr(dateObj) {
  return dateObj && isDate(dateObj)
    ? formatISO(dateObj, { representation: 'date' })
    : '';
}

export default {
  mixins: [localValue],
  props: {
    value: {
      type: [Date, Number, String, Array], // Array can only be used with multiple/range props set on v-date-picker
      validator: v => {
        return v == undefined || Array.isArray(v)
          ? v.forEach(safeParseISO)
          : safeParseISO(v);
      },
    },
    highlightedDates: {
      type: Array, // [Date], ['yyyy-MM-dd'], [Number] (JavaScript timestamp (in ms))
      default: () => [],
      // TODO: wrap in Collection[{}] to allow different event colors
    },
  },
  computed: {
    localValue: {
      get() {
        let { value } = this;

        if (!value) return null;

        if (Array.isArray(value)) {
          value = value.map(date => {
            const parsedDate = safeParseISO(date);
            return parsedDate ? dateToDateStr(parsedDate) : date;
          });
        } else {
          // Parse the input (even if it's a string not in ISO format)
          const parsedDate = safeParseISO(value);
          if (parsedDate) {
            value = dateToDateStr(parsedDate);
          } else if (typeof value === 'string' || value instanceof String) {
            // Fallback: if parsing fails, try to limit the string to 10 characters
            value = value.substr(0, 10);
          } else {
            value = dateToDateStr(toDate(value));
          }
        }
        return value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    daysArray() {
      const { highlightedDates } = this;
      let datestringsArray = highlightedDates.map(date => {
        const parsed = safeParseISO(date);
        const dateStr = parsed ? dateToDateStr(parsed) : date;
        return dateStr.substr(0, 10); // isValid returns true for timestamps/dateObjects, false for strings
      });
      return datestringsArray;
    },
  },
};
</script>

<style lang="scss" scoped></style>
